import type { ChecklistItem, ColorState } from '../lib/types';

interface Props {
  item: ChecklistItem;
  isCheckedToday: boolean;
  colorState: ColorState;
  onToggle: () => void;
}

export default function ChecklistRow({ item, isCheckedToday, colorState, onToggle }: Props) {
  const classes = [
    'row',
    isCheckedToday ? 'row--checked' : '',
    colorState === 'orange' ? 'row--orange' : '',
    colorState === 'red' ? 'row--red' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={classes} onClick={onToggle} aria-pressed={isCheckedToday}>
      <span className="row__box" aria-hidden="true">
        {isCheckedToday ? '✓' : ''}
      </span>
      <span className="row__label">{item.label}</span>
    </button>
  );
}
